import type { PaymentState } from "@/api/custom_types";
import { Dialog, DialogContent } from "@st-marketplace/ui";
import type { FC } from "react";
import PaymentResultStep from "./PaymentResultStep";

interface PaymentAddDialogStatusProps {
	method: PaymentState;
	open: boolean;
	onOpenChange: (value: boolean) => void;
	amount?: string;
	user?: string;
	message?: string;
	/** Already on the payments page? Then don't offer a link to it. */
	showPaymentsLink?: boolean;
}

/** The result step shown on its own, from the payments list. */
const PaymentAddDialogStatus: FC<PaymentAddDialogStatusProps> = ({
	method,
	open,
	onOpenChange,
	amount,
	user,
	message,
	showPaymentsLink = false,
}) => (
	<Dialog open={open} onOpenChange={onOpenChange}>
		<DialogContent className="w-full max-w-sm" showCloseButton={false}>
			<PaymentResultStep
				state={method}
				amount={amount}
				user={user}
				message={message}
				showPaymentsLink={showPaymentsLink}
				onClose={() => onOpenChange(false)}
			/>
		</DialogContent>
	</Dialog>
);

export default PaymentAddDialogStatus;
